import React, { Component } from 'react';
import { RadioButton, PagerButtons } from 'sure-components';
import PlanDisclaimer from 'shared/lib/components/PlanDisclaimer';
import PropTypes from 'prop-types';
import * as analytics from 'shared/lib/analytics';
import './BaggagePlansView.css';

const propTypes = {
  baggagePlans: PropTypes.array,
  baggageSettings: PropTypes.object,
  disclaimer: PropTypes.string,
  selectBaggagePlan: PropTypes.func,
  checkoutBaggagePlan: PropTypes.func,
  navTo: PropTypes.func,
  isBaggageInProgress: PropTypes.bool,
};

const defaultProps = {
  baggagePlans: [],
  baggageSettings: {},
  disclaimer: null,
  selectBaggagePlan: () => {},
  checkoutBaggagePlan: () => {},
  navTo: () => {},
  isBaggageInProgress: false,
};

class BaggagePlansView extends Component {
  componentDidMount() {
    analytics.page('BRB - Select a Plan');
    analytics.track('Checkout Step Viewed', {
      category: 'order',
      step: 1,
    });
  }

  handleBack = () => {
    return this.props.navTo('/baggage-protection/passenger');
  };

  handleNext = e => {
    if (e) {
      e.preventDefault();
    }

    return this.props
      .checkoutBaggagePlan()
      .then(() => {
        this.props.navTo('/baggage-protection/payment');
      })
      .catch(this.props.onError);
  };

  handlePlanSelect = e => {
    const planId = e.target.value;
    analytics.track('BRB - Plan Option Clicked', {
      category: 'plan',
      label: planId,
    });
    this.props.selectBaggagePlan(planId);
  };

  get disclaimerHtml() {
    if (this.props.baggageSettings.display_html) {
      return this.props.baggageSettings.display_html.replace(
        'href',
        'target="_blank" href'
      );
    } else {
      return null;
    }
  }

  render() {
    const {
      baggagePlans,
      isBaggageInProgress,
      baggageSelectedPlanId,
    } = this.props;

    return (
      <div className="BaggagePlansView Container Container--small">
        <h1 className="BaggagePlansView-heading">
          Select a coverage amount for your bags
        </h1>
        <form className="BaggagePlansView-form" onSubmit={this.handleNext}>
          {this.plansOptionsNode}
          {baggagePlans.map((plan, i) => (
            <RadioButton
              key={plan.plan_id}
              name="plan"
              title={plan.information.title}
              secondaryTitle={plan.information.pricing_title}
              value={plan.plan_id}
              text={plan.information.subtitle}
              checked={baggageSelectedPlanId === plan.plan_id}
              onChange={this.handlePlanSelect}
            />
          ))}
          <input type="submit" style={{ display: 'none' }} />
          <PagerButtons
            className="BaggagePlansView-cta"
            onBack={this.handleBack}
            onNext={this.handleNext}
            isInProgress={isBaggageInProgress}
            isNextDisabled={!baggageSelectedPlanId || isBaggageInProgress}
          />
        </form>
        <PlanDisclaimer text={this.disclaimerHtml} />
      </div>
    );
  }
}

BaggagePlansView.propTypes = propTypes;
BaggagePlansView.defaultProps = defaultProps;

export default BaggagePlansView;
